module.exports = __webpack_public_path__ + "media/images/country_flags/ht-423815d9e6201f23192d25b531865e67.png";